__turbopack_context__.v({
  "headingText": "styles-module__bknaiW__headingText",
});
